/* claude 表单校验（共用：文章评论、联系页、订阅）
   只在提交时校验，不做输入中的实时提示。规则写在字段外层 .claude-field 上：
     data-required        必填
     data-err-required    必填没填时的说明
     data-err-email       邮箱格式不对时的说明（input type="email"）
   出错时：外层加 .is-err、输入框 aria-invalid、说明写进 .claude-field__err，
   表单顶部 .claude-form__sum 显示「data-summary」（[n] 换成出错字段数；只有 1 处时用 data-summary-one）并获得焦点。
   被隐藏的字段（自身或祖先带 hidden）跳过。事件委托在 document 上，区块重新加载也不用重绑。 */
(function () {
  if (window.claudeFormInit) return;
  window.claudeFormInit = true;

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function setError(field, input, msg) {
    var err = field.getElementsByClassName('claude-field__err')[0];
    field.classList.add('is-err');
    input.setAttribute('aria-invalid', 'true');
    if (err) {
      var text = err.getElementsByClassName('claude-field__msg')[0] || err;
      text.textContent = msg;
      if (err.id) input.setAttribute('aria-describedby', err.id);
    }
  }

  function clearError(field, input) {
    field.classList.remove('is-err');
    input.removeAttribute('aria-invalid');
  }

  function check(form) {
    var fields = form.getElementsByClassName('claude-field');
    var bad = [];
    for (var i = 0; i < fields.length; i++) {
      var field = fields[i];
      var input = field.querySelector('input, textarea, select');
      if (!input) continue;
      clearError(field, input);
      if (field.closest('[hidden]')) continue;
      var value = (input.value || '').trim();
      var msg = '';
      if (field.hasAttribute('data-required') && value === '') {
        msg = field.getAttribute('data-err-required') || '';
      } else if (input.type === 'email' && value !== '' && !EMAIL.test(value)) {
        msg = field.getAttribute('data-err-email') || '';
      }
      if (msg) {
        setError(field, input, msg);
        bad.push(input);
      }
    }
    return bad;
  }

  function showSummary(form, count) {
    var sum = form.getElementsByClassName('claude-form__sum')[0];
    if (!sum) return;
    var text = sum.getElementsByClassName('claude-form__summsg')[0] || sum;
    var tpl = (count === 1 && sum.getAttribute('data-summary-one')) || sum.getAttribute('data-summary') || '';
    text.textContent = tpl.replace('[n]', count);
    var list = sum.getElementsByTagName('ul')[0];
    if (list) list.parentNode.removeChild(list);
    sum.hidden = false;
    sum.focus();
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.hasAttribute || !form.hasAttribute('data-geo-form')) return;
    var bad = check(form);
    if (bad.length) {
      event.preventDefault();
      showSummary(form, bad.length);
      return;
    }
    var sum = form.getElementsByClassName('claude-form__sum')[0];
    if (sum) sum.hidden = true;
  });
})();
